<template>
    <div>
        <component
            :is="getComp.comp1"
            v-bind="{ ...getComp.props1 }"
            v-model="dialog"
            :attach="attach"
            :content-class="bottom ? 'half-round' : 'soli-round'"
            @click:outside="!permanent ? reset(true) : null"
        >
            <v-card :class="[flat ? 'v-card--flat' : null, { 'half-round': bottom }, { 'limit-card-height': bottom }]">
                <v-btn
                    v-if="persistent"
                    icon
                    @click="reset"
                    class="ma-3 soli-close"
                    ><v-icon>clear</v-icon>
                </v-btn>
                <v-card-title
                    ><v-btn
                        v-if="backButton"
                        class="mr-3"
                        style="margin-left: -12px"
                        icon
                        @click="[$emit('backAction'), reset(true)]"
                        ><v-icon>chevron_left</v-icon></v-btn
                    >{{ title }}</v-card-title
                >
                <v-card-subtitle
                    v-if="subtitle"
                    class="pa-6 pb-0"
                    :class="{ 'font-weight-bold': bold }"
                    v-html="subtitle"
                >
                </v-card-subtitle>
                <div
                    class="pa-3"
                    v-if="subtitle"
                    style="max-height: 400px; overflow-y: auto"
                >
                    <slot></slot>
                </div>
                <div v-if="!textOnly">
                    <v-divider></v-divider>
                    <div :class="['pa-3', left ? null : 'flex justify-end']">
                        <v-btn
                            v-if="button2 && !showLoading1"
                            class="soli-round"
                            :color="warning ? 'primary' : 'contrast'"
                            :loading="showLoading2"
                            text
                            :block="left"
                            :disabled="disabled2"
                            @click="($emit('option2'), loading2 ? (showLoading2 = true) : reset(false))"
                        >
                            {{ button2 }}
                        </v-btn>
                        <v-btn
                            v-if="button3"
                            class="soli-round"
                            :color="button3Color"
                            :loading="showLoading3"
                            text
                            :block="left"
                            :disabled="disabled3"
                            @click="($emit('option3'), loading3 ? (showLoading3 = true) : reset(false))"
                        >
                            {{ button3 }}
                        </v-btn>
                        <v-btn
                            v-if="button1"
                            :loading="showLoading1"
                            class="soli-round"
                            :color="warning || warning1 ? 'error' : 'primary'"
                            :disabled="disabled1"
                            text
                            :block="left"
                            :href="link1 ?? null"
                            @click="[$emit('option1'), loading1 ? (showLoading1 = true) : reset(false)]"
                        >
                            {{ button1 }}
                        </v-btn>
                    </div>
                </div>
                <div
                    class="px-3 pb-3"
                    v-if="textOnly"
                >
                    <slot></slot>
                </div>
            </v-card>
        </component>
    </div>
</template>

<script>
import { VDialog, VBottomSheet } from 'vuetify/lib';

export default {
    name: 'SoliChoice',
    components: {
        VDialog,
        VBottomSheet,
    },
    props: {
        errors: Object,
        title: String,
        textOnly: { type: Boolean, default: false },
        button1: [String, Boolean],
        button2: [String, Boolean],
        button3: [String, Boolean],
        link1: String,
        warning: Boolean,
        warning1: {
            type: Boolean,
            default: false,
        },
        subtitle: String,
        disabled1: Boolean,
        disabled2: Boolean,
        disabled3: Boolean,
        flat: Boolean,
        left: { type: Boolean, default: false },
        loading1: { type: Boolean, default: false },
        loading2: { type: Boolean, default: false },
        loading3: { type: Boolean, default: false },
        bottom: { type: Boolean, default: false },
        permanent: {
            type: Boolean,
            default: false,
        },
        persistent: {
            type: Boolean,
            default: false,
        },
        backButton: {
            type: Boolean,
            default: false,
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
        bold: {
            type: Boolean,
            default: false,
        },
        button3Color: { String, default: 'contrast' },
        attach: {
            type: [String, Boolean],
            default: false,
        },
    },
    data() {
        return {
            dialog: null,
            showLoading1: false,
            showLoading2: false,
            showLoading3: false,
        };
    },
    computed: {
        getComp() {
            return {
                comp1: this.flat ? 'div' : this.bottom ? 'v-bottom-sheet' : 'v-dialog',
                props1: {
                    //"v-on: click:outside": "reset",
                    'max-width': this.$vuetify.breakpoint.xs ? 'inherit' : '380',
                    persistent: this.permanent ? true : false,
                    'content-class': 'desktop-scroll',
                },
            };
        },
    },
    methods: {
        reset(event) {
            this.dialog = false;
            setTimeout(() => {
                this.$emit('reset', event);
            }, 500);
        },
    },
    mounted() {
        this.dialog = true;
    },
};
</script>

<style scoped>
.limit-card-height {
    max-height: calc(100vh - 48px);
    overflow-y: auto;
    padding-bottom: 64px;
}
</style>
